import { useEffect, useState } from 'react';
import { ProjectSettings } from 'shared/types/projectSettings/ProjectSettings';
import ContentStackImage from '@/components/customercenter-ui/common/contentStackImage/contentStackImage';
import { useProjSettings } from '@/frontastic/hooks/useProjectSettings/useProjectSettings';
import { getCookieValue } from '@/helpers/utils/siteUtils';
import useSiteTranslation from '@/providers/i18n/hooks/useSiteTranslation';
import { COOKIE_KEYS, PAGE_TEXTS_KEYS } from '../../../../../../../constants/constant';
import { Button } from '../../../../ui/button';
import { CardContent } from '../../../../ui/card';
import InputField from '../../../../ui/customInput/input';

const Index = ({
  FORM_FIELD_SPECS,
  selectedSearchType,
  searchParams,
  errors,
  register,
  resetFormOnInteraction,
  formWrapperKey,
  setFormWrapperKey,
  setSearchParams,
  setValue,
}: any) => {
  const projectSettings: ProjectSettings = useProjSettings();
  const Texts = useSiteTranslation(PAGE_TEXTS_KEYS?.customerAndOrderSearch);
  const [imageURL, setImageURL] = useState<string>();

  const catalogIdSearchParam = searchParams?.[FORM_FIELD_SPECS?.catalogId?.id];
  const truncatedCatalogIdSearchParam = catalogIdSearchParam?.substring(0, projectSettings?.catalogIdMaxLimit ?? 10);

  useEffect(() => {
    const divisionCode = getCookieValue(COOKIE_KEYS.selectedSite)?.slice(0, 2) ?? 'ZB';
    const host = divisionCode && JSON.parse(projectSettings?.catalogIdImageURLs ?? '')[divisionCode];
    setImageURL(host);
  }, []);

  return (
    <CardContent className="space-y-2 lg:pr-0">
      <div className="flex w-full" key={formWrapperKey?.[FORM_FIELD_SPECS?.catalogId?.id]}>
        <InputField
          items={`${Texts?.catalogId}`}
          id={FORM_FIELD_SPECS?.catalogId?.id}
          htmlFor={FORM_FIELD_SPECS?.catalogId?.id}
          register={register}
          errors={errors}
          label={Texts?.catalogId}
          classname="w-full"
          rules={{
            required: Texts?.catalogIdRequired,
          }}
          defaultValue={truncatedCatalogIdSearchParam}
          maxLength={projectSettings?.catalogIdMaxLimit ?? 10}
          hideError
          isNum
          onChange={() => {
            resetFormOnInteraction();
            setSearchParams({ ...searchParams, [FORM_FIELD_SPECS?.otherIdentifierId?.id]: '' });
            setFormWrapperKey({
              ...formWrapperKey,
              [FORM_FIELD_SPECS?.otherIdentifierId?.id]: `key_${selectedSearchType}_${
                FORM_FIELD_SPECS?.otherIdentifierId?.id
              }_${Math.floor(Date.now())}}`,
            });
          }}
          handlePaste={() => {
            resetFormOnInteraction();
            setSearchParams({ ...searchParams, [FORM_FIELD_SPECS?.otherIdentifierId?.id]: '' });
            setFormWrapperKey({
              ...formWrapperKey,
              [FORM_FIELD_SPECS?.otherIdentifierId?.id]: `key_${selectedSearchType}_${
                FORM_FIELD_SPECS?.otherIdentifierId?.id
              }_${Math.floor(Date.now())}}`,
            });
          }}
          setValue={setValue}
        />
        <Button className="ml-5 h-auto bg-[#002C4E] px-8 text-18 text-white" type="submit">
          <span className="text-lg font-semibold text-white">{Texts?.searchButtonText}</span>
        </Button>
      </div>
      {errors?.[FORM_FIELD_SPECS?.catalogId?.id] && (
        <p className="mt-2 text-sm text-scarletRed">{errors[FORM_FIELD_SPECS?.catalogId?.id]?.message}</p>
      )}
      <p className="pb-3 text-14 font-normal text-[#222222]">{Texts?.catalogIdHelp}</p>
      {imageURL && <ContentStackImage src={imageURL ?? ''} imageHeight={64} imageWidth={262} className="mt-10" />}
    </CardContent>
  );
};

export default Index;
